











import { defineClassComponent } from '@/hooks'

export default defineClassComponent<{
  value: boolean
}>(
  {
    props: ['value'],
  },
  () => class {},
)
